import React, { useState, useRef, useEffect } from "react";

const HistoryRecordsTooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [isPositionedAbove, setIsPositionedAbove] = useState(false);
  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (showTooltip && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const tooltipHeight = 150;

      const updatePosition = () => {
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;

        // Position above if not enough space below
        const shouldPositionAbove =
          spaceBelow < tooltipHeight && spaceAbove > spaceBelow;
        setIsPositionedAbove(shouldPositionAbove);

        setPosition({
          left: rect.left + rect.width / 2,
          top: shouldPositionAbove
            ? rect.top - tooltipHeight - 10
            : rect.bottom + 15,
        });
      };

      updatePosition();
      window.addEventListener("resize", updatePosition);

      return () => {
        window.removeEventListener("resize", updatePosition);
      };
    }
  }, [showTooltip]);

  return (
    <button
      ref={triggerRef}
      className="btn btn-link p-0 clickLink smallLink"
      aria-label="Learn about historical records"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      type="button"
    >
      {showTooltip && (
        <div
          ref={tooltipRef}
          className="results-tooltip"
          role="tooltip"
          style={{
            position: "fixed",
            left: `${position.left}px`,
            top: `${position.top}px`,
            transform: "translateX(-50%)",
            zIndex: 100,
            width: "300px",
            backgroundColor: "#ebebeb",
            border: "1px solid rgba(31, 31, 31, 0.2)",
            color: "#000",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 0,
            pointerEvents: "none",
            opacity: 1,
            transition: "opacity 0.2s ease-in-out",
            fontFamily: "Open Sans, sans-serif",
            fontSize: "12px",
            fontWeight: "400",
            lineHeight: "1.5",
          }}
        >
          <div style={{ position: "relative" }}>
            {!isPositionedAbove && (
              <>
                <div
                  style={{
                    position: "absolute",
                    top: "-8px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderBottom: "8px solid #0003",
                  }}
                ></div>
                <div
                  style={{
                    position: "absolute",
                    top: "-7px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "7px solid transparent",
                    borderRight: "7px solid transparent",
                    borderBottom: "7px solid #ebebeb",
                  }}
                ></div>
              </>
            )}
            {isPositionedAbove && (
              <>
                <div
                  style={{
                    position: "absolute",
                    bottom: "-8px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderTop: "8px solid #0003",
                  }}
                ></div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "-7px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "7px solid transparent",
                    borderRight: "7px solid transparent",
                    borderTop: "7px solid #ebebeb",
                  }}
                ></div>
              </>
            )}
            <div
              className="popover-body"
              style={{
                padding: "12px",
                textAlign: "left",
              }}
            >
              <p style={{ margin: 0 }}>
                A history record is an event reported to AutoCheck by a vetted,
                reputable source that provides insight into the history of a
                vehicle and may include accidents, mileage, service history,
                number of vehicle owners and title brands like salvage and total
                loss. Get the full vehicle history report to learn more.
              </p>
            </div>
          </div>
        </div>
      )}
    </button>
  );
};

export default HistoryRecordsTooltip;
